import React from "react";

//package import

import { Hidden, Drawer, useTheme, Box } from "@mui/material";
import { drawerClasses } from "@mui/material/Drawer";
import PropTypes from "prop-types";

import { InsideDrawer } from "./Drawer";

function Sidebar({ mobileOpen, handleDrawerToggle }) {
  //hooks

  const theme = useTheme();

  return (
    <>
      <Box
        component="nav"
        sx={{
          width: { md: " 19.9vw" },
          flexShrink: { sm: 0 },
          marginTop: 50,
        }}
      >
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            sx={{
              display: { xs: "block", sm: "block", md: "none" },
              [`& .${drawerClasses.paper}`]: {
                boxSizing: "border-box",
                width: { md: " 19.9vw" },
                backgroundColor: theme.palette.background.paper,
                // zIndex: -99,
              },
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <InsideDrawer />
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            sx={{
              display: { xs: "none", sm: "none", md: "block" },
              [`& .${drawerClasses.paper}`]: {
                boxSizing: "border-box",
                width: { md: " 19.9vw" },
                backgroundColor: theme.palette.background.paper,

                // zIndex: -99,
              },
            }}
            variant="permanent"
          >
            <InsideDrawer />
          </Drawer>
        </Hidden>
      </Box>
    </>
  );
}

Sidebar.propTypes = {
  mobileOpen: PropTypes?.bool?.isRequired,
  handleDrawerToggle: PropTypes?.func?.isRequired,
};

export default Sidebar;
